import React from 'react';
import AppSplash from '../AppSplash/AppSplash';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * MentorProtectedRoute — wraps mentor-only routes.
 * Redirects unauthenticated users to /login.
 * Redirects authenticated TEACHER users to /teacher/dashboard.
 */
function MentorProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <AppSplash />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Only MENTOR and ADMIN roles can access mentor routes
  if (user?.role === 'TEACHER' || user?.role === 'STUDENT') {
    return <Navigate to="/teacher/dashboard" replace />;
  }

  return children;
}

export default MentorProtectedRoute;
